<template>
    <div class="tasks" v-if="current">
        <LearnStep :hidePlusTasks="tasks_plus"/>
        <v-row v-if="$vuetify.breakpoint.smAndUp" class="rest_height" @wheel="() => $refs.rightPanel.scrollOverflowHandler()">
            <LeftPanel @pickSub="sub => pickedSub(sub)" @unpickSub="pickedSub(picked_sub)"/>
            <RightPanel ref="rightPanel"/>
            <!-- <v-tab-item class="tabs-dummy" v-if="!tasks.length"></v-tab-item> -->
        </v-row>
        <TaskViewMobile v-else/>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import {relevantNotices, searchNotices} from '../../../helpers'
    import LearnStep from '../learn/LearnStep'
    import LeftPanel from './LeftPanel'
    import RightPanel from './RightPanel'
    import TaskViewMobile from './TaskViewMobile'
    export default {
        name: 'TaskView',
        components:{
          LearnStep,
          LeftPanel,
          RightPanel,
          TaskViewMobile
        },
        data() {
          return {
            tasks_plus: true,
          }
        },
        computed:{
          ...mapGetters(["current" , "current_task", "feeds", "picked_sub"]),
        },
        methods:{
          ...mapActions(["setRelavantNoticesByRoute"]),
          ...mapMutations(['SET_CURRENT_BY_ROUTE', 'TOGGLE_PICKED_SUB']),                  
          pickedSub(sub) {
              const relNotices = relevantNotices(this.feeds, this.current_task)
              const relNoticesForSub = []
              searchNotices(relNotices, sub, relNoticesForSub)
              this.TOGGLE_PICKED_SUB({sub, relNotices, relNoticesForSub})
              // const elementSub = document.getElementById(`sub-id-${sub._id}`)
              // const elementSubScroll = elementSub.getBoundingClientRect()
              // if(elementSubScroll.height > 68) {
              //   this.$vuetify.goTo(`#sub-id-${sub._id}`, {offset: elementSubScroll.top - 64})
              // } 
          },
        },
        async mounted() {
          if(this.$route.params.task){
            this.SET_CURRENT_BY_ROUTE({theme: this.$route.params.theme})
            await this.setRelavantNoticesByRoute(this.$route.params.task)
          }else{
            this.SET_CURRENT_BY_ROUTE({theme: this.$route.params.theme})
          }
          this.$root.$on('addTask', () => {
            this.tasks_plus = false
          }) 
          this.$root.$on('toCurrentSub', (sub) => { 
            this.pickedSub(sub)
          }) 
        },
    }
</script>

<style lang="scss">
.col{
    padding: 12px 6px !important;
}
.rest_height {
    min-height: calc(100vh - 194px);
    width: calc(100% + 13px);
}
</style>